import {PATHS} from 'routes/constants';

export type ScreenArea = 'home' | 'iv' | 'guest_form' | 'payments' | 'other';

export interface ScreenInfo {
  area: ScreenArea;
  step: string;
}

const IV_STEP_BY_SEGMENT: Record<string, string> = {
  [PATHS.verification.documentSelection]: 'document_selection',
  [PATHS.verification.front]: 'front_scan',
  [PATHS.verification.back]: 'back_scan',
  [PATHS.verification.selfie]: 'selfie',
  [PATHS.verification.contacts]: 'contacts',
};

const GUEST_FORM_SEGMENTS = [PATHS.guestRegistration, PATHS.addPersonalDataForm];

export function getScreenInfo(pathname: string): ScreenInfo {
  const path = pathname.toLowerCase();
  const segments = path.split('/').filter(Boolean);

  if (segments.includes(PATHS.verification.main)) {
    const matched = segments.find(segment => IV_STEP_BY_SEGMENT[segment]);
    return {area: 'iv', step: matched ? IV_STEP_BY_SEGMENT[matched] : 'start'};
  }

  if (GUEST_FORM_SEGMENTS.some(segment => path.includes(segment))) {
    return {area: 'guest_form', step: 'form'};
  }

  if (segments.includes(PATHS.payments.main)) {
    return {area: 'payments', step: segments[segments.length - 1] ?? 'payments'};
  }

  if (segments.length <= 1) {
    return {area: 'home', step: 'home'};
  }

  return {area: 'other', step: segments[segments.length - 1] ?? 'unknown'};
}
